import type { ColorPickerDesignTokens } from '@primeuix/themes/types/colorpicker'

export default {
  root: {
    transitionDuration: '{transition.duration}',
  },
  panel: {
    shadow: '{overlay.popover.shadow}',
    borderRadius: '{overlay.popover.borderRadius}',
  },
  preview: {
    width: '1.75rem',
    height: '1.75rem',
    focusRing: {
      color: '{form.field.focus.ring.color}',
      style: '{form.field.focus.ring.style}',
      width: '{form.field.focus.ring.width}',
      offset: '{form.field.focus.ring.offset}',
      shadow: '{form.field.focus.ring.shadow}',
    },
    borderRadius: '{form.field.border.radius}',
  },
  colorScheme: {
    dark: {
      panel: {
        background: '{surface.900}',
        borderColor: '{surface.700}',
      },
      handle: {
        color: '{surface.0}',
      },
    },
    light: {
      panel: {
        background: '{surface.800}',
        borderColor: '{surface.900}',
      },
      handle: {
        color: '{surface.0}',
      },
    },
  },
} satisfies ColorPickerDesignTokens
